import projects from '../utilities/project-data';
import React from "react";
// import { Carousel } from 'react-bootstrap';
import * as SimpleIcons from "react-icons/si";

function ProjectSlide( {ProjectID} ) {
    return (
            <div className="slide-content slide-layout">
                <img
                className="d-block w-100" src={`${projects[ProjectID].image}`}
                alt="First slide"
                />
                <div className="slide-project-data">
                    <div className="title-and-link-container">
                        <h3>{projects[ProjectID].title}</h3>
                        <a className="single-project-link grow" href={projects[ProjectID].external_link}>See Website</a>
                    </div>
                    <div className="tech-stack">
                        <h3>Tech Stack:</h3> {projects[ProjectID].techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                    </div>
                    <p className="project-description">{projects[ProjectID].long_description}</p>
                </div>
            </div>
    )
}

export default ProjectSlide